import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import dsBankApi from "service/TichHopBank/dsBankApi";
import { pushNotification } from "utils/notifications";
import DanhDachIcloudApi from "../../../../service/QuanTriHeThong/DanhDachIcloudApi";
import { getUserLogin } from "utils/user";

export const ThemMoi = (props) => {
  const dispatch = useDispatch();

  const initDataAddAndEditnew = {
    Id: 0,
    TenTaiKhoan: "",
    SoDienThoai: "",
    MatKhau: "",
    GhiChu: "",
    IsHanChe: false,
    IsXoa: true,
  };
  const [bDisable, setDisableButton] = useState(false);
  const [dataAddAndEditNew, setDataAddAndEdit] = useState(
    initDataAddAndEditnew
  );
  const [bDisableTextSua, setDisableTextSua] = useState(false);
  const currentForm = useForm();
  const { handleSubmit } = currentForm;

  useEffect(() => {
    if (typeof props.data.Id != "undefined" && props.data.Id > 0) {
      setDataAddAndEdit(props.data);
      if (props.data.SoHDLienKet > 0) {
        setDisableTextSua(true);
      }
    }
  }, [props.data.Id]);

  const updateTextValue = (field) => (e) => {
    const data = { ...dataAddAndEditNew };
    data[field] = e.target.value;
    setDataAddAndEdit(data);
  };
  const toggleCheckHanChe = () => {
    const data = { ...dataAddAndEditNew };
    data.IsHanChe = !data.IsHanChe;
    setDataAddAndEdit(data);
  };

  const addOrEdit = () => {
    if (dataAddAndEditNew.SoDienThoai === "") {
      pushNotification("Nhập số điện thoại!", "error", "TOP_CENTER", 2000);
      return;
    }
    if (dataAddAndEditNew.TenTaiKhoan === "") {
      pushNotification("Nhập tên tài khoản!", "error", "TOP_CENTER", 2000);
      return;
    }
    if (dataAddAndEditNew.MatKhau === "") {
      pushNotification("Nhập mật khẩu!", "error", "TOP_CENTER", 2000);
      return;
    }
    dataAddAndEditNew.NguoiTao = getUserLogin().UserName;
    setDisableButton(true);
    DanhDachIcloudApi.addOrUpdate(dataAddAndEditNew).then((response) => {
      setDisableButton(false);
      if (response.status === 200) {
        props.data.onSearch();
        setDataAddAndEdit(initDataAddAndEditnew);
        props.onHide();
        pushNotification("Thao tác thành công", "success", "TOP_CENTER", 2000);
      } else {
        pushNotification(response, "error", "TOP_CENTER", 2000);
      }
    });
  };

  return (
    <Modal
      {...props}
      size="modal-new-size modal-new-size"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="fas fa-plus"></i>
          </span>{" "}
          {dataAddAndEditNew.Id > 0 ? "Sửa" : "Thêm mới"} tải khoản Icloud
        </h4>
        <button
          type="button"
          className="close-popup-new"
          data-dismiss="modal"
          aria-label="Close"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="form-body">
          <div className="card collapse-icon accordion-icon-rotate">
            <div
              id="headingCollapse196"
              className="card-header border-info"
              href="#collapse196"
              aria-expanded="true"
              aria-controls="collapse196"
            >
              <a className="card-title lead info collapsed" href={() => false}>
                <h3>Thông tin</h3>
              </a>
            </div>
            <div
              id="collapse196"
              aria-labelledby="headingCollapse96"
              className="card-collapse collapse show"
              aria-expanded="true"
            >
              <div className="card-content">
                <div className="form-group row">
                  <label className="col-md-2 label-control">
                    Tên tài khoản <span className="canh-bao-red">*</span>
                  </label>
                  <div className="col-md-4">
                    <input
                      type="text"
                      className="form-control input-sm"
                      value={dataAddAndEditNew.TenTaiKhoan}
                      onChange={updateTextValue("TenTaiKhoan")}
                      disabled={bDisableTextSua}
                    />
                  </div>
                  <label className="col-md-2 label-control">
                    Mật khẩu <span className="canh-bao-red">*</span>
                  </label>
                  <div className="col-md-4">
                    <input
                      type="text"
                      className="form-control input-sm"
                      value={dataAddAndEditNew.MatKhau}
                      onChange={updateTextValue("MatKhau")}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-md-2 label-control">
                    Số điện thoại <span className="canh-bao-red">*</span>
                  </label>
                  <div className="col-md-4">
                    <input
                      type="text"
                      className="form-control input-sm"
                      value={dataAddAndEditNew.SoDienThoai}
                      onChange={updateTextValue("SoDienThoai")}
                      disabled={bDisableTextSua}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-md-2 label-control">Hạn chế</label>
                  <div className="col-md-10">
                    <input
                      style={{ marginRight: "10px" }}
                      type="checkbox"
                      checked={dataAddAndEditNew.IsHanChe}
                      value={dataAddAndEditNew.IsHanChe}
                      onChange={toggleCheckHanChe}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-md-2 label-control">Ghi chú</label>
                  <div className="col-md-10">
                    <textarea
                      rows="3"
                      className="form-control input-sm"
                      placeholder="Ghi chú"
                      value={dataAddAndEditNew.GhiChu}
                      onChange={updateTextValue("GhiChu")}
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="modal-footer">
        <button
          className="btn btn-new-main btn-checknew"
          onClick={addOrEdit}
          disabled={bDisable}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-check"></i>
          </span>
          {dataAddAndEditNew.Id > 0 ? "Cập nhật" : "Thêm mới"}
        </button>

        <a
          className="btn btn-new-main btn-closenew"
          data-dismiss="modal"
          href={() => false}
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>{" "}
          Đóng
        </a>
      </Modal.Footer>
    </Modal>
  );
};
